import { render, staticRenderFns } from "./ApplicationFormSettings.vue?vue&type=template&id=70af39d4&scoped=true"
import script from "./ApplicationFormSettings.vue?vue&type=script&lang=js"
export * from "./ApplicationFormSettings.vue?vue&type=script&lang=js"
import style0 from "./ApplicationFormSettings.vue?vue&type=style&index=0&id=70af39d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70af39d4",
  null
  
)

export default component.exports